/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostSearchDataItemSegment
 */
export interface PostSearchDataItemSegment {
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemSegment
     */
    from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemSegment
     */
    to?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemSegment
     */
    flightNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemSegment
     */
    _class?: string | null;
    /**
     * 
     * @type {object}
     * @memberof PostSearchDataItemSegment
     */
    departure?: object;
    /**
     * 
     * @type {object}
     * @memberof PostSearchDataItemSegment
     */
    arrival?: object;
}

export function PostSearchDataItemSegmentFromJSON(json: any): PostSearchDataItemSegment {
    return PostSearchDataItemSegmentFromJSONTyped(json, false);
}

export function PostSearchDataItemSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostSearchDataItemSegment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'flightNumber': !exists(json, 'flightNumber') ? undefined : json['flightNumber'],
        '_class': !exists(json, 'class') ? undefined : json['class'],
        'departure': !exists(json, 'departure') ? undefined : json['departure'],
        'arrival': !exists(json, 'arrival') ? undefined : json['arrival'],
    };
}

export function PostSearchDataItemSegmentToJSON(value?: PostSearchDataItemSegment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
        'flightNumber': value.flightNumber,
        'class': value._class,
        'departure': value.departure,
        'arrival': value.arrival,
    };
}


